import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import {
  useGetLocalTransportDetailQuery,
  useUpdateLocalTransportMutation,
} from "store/services/localTransportApi";
import { useAppMeta } from "hooks";
import LocalTransportForm from "./LocalTransportComponents/LocalTransportForm";

const LocalTransportEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: localTransportDetail, isLoading: loadingDetail } =
    useGetLocalTransportDetailQuery(id);
  const [updateLocalTransport, { isLoading: updating }] =
    useUpdateLocalTransportMutation();

  const breadcrumbs = [
    { title: "Local Transports", path: "/app/crm/local-transport/list" },
    { title: "Edit Request" },
  ];

  const handleUpdate = async (data) => {
    try {
      await updateLocalTransport({ _id: id, ...data }).unwrap();
      toast.success("Local Transport updated!");
      navigate(`/app/crm/local-transport/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Update failed.");
    }
  };

  useAppMeta("Edit Local Transport");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDetail || updating}
    >
      <BreadcrumbLayout.Paper>
        <LocalTransportForm
          isBusy={loadingDetail || updating}
          localTransportDetail={localTransportDetail}
          onSubmit={handleUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LocalTransportEditScreen;
